import { Alert, List, Text } from '@ksyos/design-system';
import { useState } from 'react';

export function ExaminationDetailsModal() {
    const [showInspectionDetails, setShowInspectionDetails] = useState(false);

    return (
        <Alert
            appearance="info"
            hasIcon={true}
        >
            Inspectie van de keel is essentieel en voorkomt wellicht een verwijzing naar de KNO arts <br />
            <Text size="sm">
                <Alert.Link
                    fontWeight="normal"
                    iconLeft={showInspectionDetails ? 'caret-up' : 'caret-down'}
                    mt={2}
                    onClick={() => setShowInspectionDetails(!showInspectionDetails)}
                    variant="button"
                >
                    Hoe dit correct uit te voeren
                </Alert.Link>
            </Text>
            {showInspectionDetails && (
                <div style={{ marginLeft: '26px', marginTop: '8px' }}>
                    <Alert.Text
                        as="p"
                        size="md"
                    >
                        Vraag de patiënt om:
                    </Alert.Text>

                    <List
                        styleType="bullet"
                        sx={{ mt: '8px' }}
                    >
                        <List.Item>te zitten met het hoofd in een neutrale positie</List.Item>
                        <List.Item>
                            zijn of haar mond zo wijd mogelijk te openen en de tong zo ver mogelijk uit te steken
                        </List.Item>
                        <List.Item>tijdens de beoordeling geen geluiden te maken</List.Item>
                    </List>
                </div>
            )}
        </Alert>
    );
}
